// extracted by mini-css-extract-plugin
module.exports = {"partnerCompIframe":"styles_partnerCompIframe__jjaiU"};